"use strict"

import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { setupEndpoints, STATICS } from "./syos-config";

export function init() {
    isLoggedIn().then(loggedIn => {
        if (loggedIn) {
            document.body.classList.add('user-logged-in');
        } else {
            document.body.classList.add('user-logged-out');
        }
    }).catch(e => {
        console.error('Failed to get logged in status', e);
        document.body.classList.add('user-logged-out');
    });

    document.querySelectorAll('.js-append-returnurl').forEach(el => {
        const separator = el.dataset.href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${el.dataset.href}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}

async function isLoggedIn() {
    try {
        await setupEndpoints();

        const sessionKey = await getSessionKey();
        if (!sessionKey) {
            return false;
        }

        const response = await fetchPolyfill(`${STATICS.PROXY}/Web/Session/${sessionKey}`);
        const data = await response.json();

        return data.IsLoggedIn;
    } catch (error) {
        return false;
    }
}

async function getSessionKey() {
    return fetchPolyfill(`${STATICS.TNEW}/api/session/sessionkey/`, {
            credentials: 'include',
        })
        .then(r => r.json())
        .then(r => (r.encryptedSessionKey))
        .then(encryptedSessionKey => {
            return fetchPolyfill(`${STATICS.PROXY}/decrypt`, {
                method: 'POST',
                body: JSON.stringify({ key: encryptedSessionKey }),
                headers: {
                    'Content-Type': 'application/json'
                },
            });
        })
        .then(r => r.json())
        .catch(e => {
            console.error('Failed to get TNEW Session Key', e);
            return false;
        });
}
